import { registerComponent } from '@copilotkit/angular';
import { z } from 'zod';
import { ContactOptionsCardComponent } from './contact-options-card.component';

export const CONTACT_SUPPORT_TOOL_NAME = 'show_contact_options';

const CONTACT_SUPPORT_DESCRIPTION = [
  'Show the PALFINGER contact options so the user can reach a human.',
  'Call this when you cannot answer the question, when the answer needs',
  'account, order or warranty data you cannot see, or when the user asks to',
  'talk to a person. Write no contact details yourself: the card already',
  'shows the right ones for this user.',
].join(' ');

/** Must be called from an injection context; unregisters with that injector. */
export function registerContactSupportTool(): void {
  registerComponent({
    name: CONTACT_SUPPORT_TOOL_NAME,
    description: CONTACT_SUPPORT_DESCRIPTION,
    parameters: z.object({
      subject: z
        .string()
        .describe(
          'A short ticket subject summarising what the user needs help with, ' +
            'in their language. Used to prefill a support ticket, so describe ' +
            'the problem rather than the request for help.',
        ),
    }),
    component: ContactOptionsCardComponent,
  });
}
